import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=4b0ad3c4&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
import style0 from "./Detail.vue?vue&type=style&index=0&id=4b0ad3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ad3c4",
  null
  
)

export default component.exports